/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function UnidadesMedida() {
  return (
    <PaginasEspecificas posicao="16" endereco="/fisica" materia="Física" />
  );
}

export default UnidadesMedida;
